import { render, staticRenderFns } from "./IcoFlashCardContent.vue?vue&type=template&id=5f2c9201"
import script from "./IcoFlashCardContent.vue?vue&type=script&lang=js"
export * from "./IcoFlashCardContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports